/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Inject,
  Injectable,
  InjectionToken,
  Injector,
  makeStateKey,
  Optional,
  PLATFORM_ID,
  TransferState
} from '@angular/core';
import { Config } from '../../models/utils';

export const HEADER_CONFIGURATION_URL: InjectionToken<string> =
  new InjectionToken<string>('');

const CONFIG_KEY = makeStateKey('CONFIG');

@Injectable({
  providedIn: 'root'
})
export class ApplicationConfig {
  private _config: Config = {} as Config;
  private headerConfigUrl = '';

  constructor(
    @Inject(PLATFORM_ID) private _platformId: object,
    @Optional() @Inject(HEADER_CONFIGURATION_URL) private configUrl: string,
    private http: HttpClient,
    private injector: Injector,
    private cache: TransferState
  ) {
    this.headerConfigUrl = this.configUrl;
    if (!this.headerConfigUrl) {
      if (isPlatformServer(this._platformId)) {
        this._config = this.injector.get('CONFIG_TOKEN');
        this.cache.set(CONFIG_KEY, this._config as any);
      } else {
        if (window) {
          this.setConfigFromTransferState();
        } else {
          this._config = {};
        }
      }
    }
  }

  setConfigFromTransferState(): void {
    let transferState = this.cache.get(CONFIG_KEY, undefined as any);
    if (transferState) {
      this._config = transferState;
    } else if (
      (window as { [key: string]: any })['HEADER'] !== undefined &&
      (window as { [key: string]: any })['HEADER'] !== null
    ) {
      transferState = (window as { [key: string]: any })['HEADER'];
      this._config = transferState;
    } else {
      this._config = {};
    }
  }

  get(key: string): string {
    let value = '';
    if (this._config) {
      value = this._config[`${key}`];
    }
    return value ? value : '';
  }

  loadConfiguration(): Promise<boolean> {
    return this.http
      .get<Config>(this.headerConfigUrl)
      .toPromise()
      .then((response) => {
        this._config = response;
      })
      .then(() => Promise.resolve(true))
      .catch((error) => {
        console.error('Error loading config', error);
        return Promise.resolve(false);
      });
  }

  loadConfig() {
    return this._config;
  }

  get onServer(): boolean {
    return isPlatformServer(this._platformId);
  }

  get onBrowser(): boolean {
    return !this.onServer;
  }
}
